import React, { Suspense } from 'react';

import './index.scss';

import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { styled, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { WLoadingProvider, GlobalErrorBoundary } from './features/common';

import './libs/i18n/i18n';
import './libs/firebase/firebase';
import './libs/sentry';
import loadClarity from './utils/clarity';
import env from './config/env';
import { store, queryClient } from './libs';
import * as serviceWorker from './serviceWorker';
import 'barcode-detector/polyfill';

import { theme as WarecloudsTheme } from './features/ui/theme';
import App from './App';
import { createRoot } from 'react-dom/client';

import { MaterialDesignContent } from 'notistack';

loadClarity(env.CLARITY_ID);

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-info': {
    backgroundColor: '#5938bd',
  },
}));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback="...is loading">
          <ThemeProvider theme={WarecloudsTheme}>
            <SnackbarProvider
              Components={{
                info: StyledMaterialDesignContent,
              }}
              maxSnack={3}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <WLoadingProvider>
                <GlobalErrorBoundary>
                  <App />
                </GlobalErrorBoundary>
              </WLoadingProvider>
            </SnackbarProvider>
          </ThemeProvider>
        </Suspense>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

if ('serviceWorker' in navigator && 'PushManager' in window) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`/firebase-messaging-sw.js?config=firebase-config.js`)
      .then((registration) => {
        console.info('Service worker registered', registration);
      })
      .catch((err) => {
        console.error('Service worker not registered', err);
      });
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
